<template>
  <div class="product_inf" style="">
    <div class="bg_top"></div><!--滑动门背景增加代码-->
    <div class="bg_con"><!--滑动门背景增加代码-->
      <span
        style="padding:0.2rem 0 0.2rem;font-size: 1.5rem;color: #ffffff;display: inline-block;width:100%;text-align: center">{{
          title
        }}</span>
      <div style="margin: 0px 1.8rem 0 1.6rem;">
        <slot></slot>
      </div>
    </div>
    <div class="bg_bottom"></div><!--滑动门背景增加代码-->
  </div>
</template>

<script>

  export default {
    name: '',
    components: {},
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>


<style lang="less" scoped>

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.bg_top {
  width: 100%;
  height: 2rem;
  background: url(~@/assets/peerfintechimg/FmnENed1n9V3831l6ftRrZEcAonP.png);
  //background: url(https://images.peerfintech.cn/FmnENed1n9V3831l6ftRrZEcAonP);
  background-size: 100% 100%;
}

.bg_con {
  width: 100%;
  height: 100%;
  padding: 0 0.8rem 0 1.1rem;
  background: url(~@/assets/peerfintechimg/FuG_S5o3s7Ey3q-ynTAW3330gHpq.png) repeat-y;
  //background: url(https://images.peerfintech.cn/FuG_S5o3s7Ey3q-ynTAW3330gHpq) repeat-y;
  background-size: 100%;
}

.bg_bottom {
  width: 100%;
  height: 3rem;
  background: url(../../../assets/card/bg-bottom.png);
  background-size: 100% 100%;
  margin-top: -1rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}
</style>
